var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "75px",
    height: "74.8px",
    viewBox: "0 0 75 74.8",
    style: {
      enableBackground: "new 0 0 75 74.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6,8.1h-4.2h0c-0.8-4.5-4.7-7.7-9.2-7.7S42.8,3.7,42,8.1h-8.6C32.7,3.5,28.7,0,24,0s-8.7,3.5-9.3,8.1h-4.2 C4.8,8,0.1,12.6,0,18.3v45.8c-0.1,2.8,1,5.5,3,7.5c2,2,4.6,3.1,7.4,3.1h54.2h0c2.8,0,5.4-1.1,7.4-3.1s3.1-4.6,3.1-7.4V18.5 c0-2.8-1.1-5.4-3.1-7.4C70,9.2,67.3,8.1,64.6,8.1L64.6,8.1z M51.1,4.4c2.3,0,4.3,1.5,4.9,3.8h-9.8c0.5-2.3,2.6-3.9,4.9-4V4.4z  M24,4.4c2.3,0,4.3,1.5,4.9,3.8h-9.8c0.5-2.3,2.6-3.9,4.9-4V4.4z M10.4,12.3h18c-0.8,2.2-4.9,2-4.2,4.9c2.2,4.2,8.1-2,8.6-4.9h22.6 c-0.8,2.2-4.9,2-4.2,4.9c2.2,4.2,8.1-2,8.6-4.9h4.7c3.4,0,6.1,2.7,6.2,6v6.5H4.2v-6.5C4.3,15,7,12.3,10.4,12.3L10.4,12.3z  M64.6,70.6H10.4c-1.7,0-3.3-0.7-4.5-1.9s-1.8-2.9-1.8-4.6V29h66.7v35.4v0C70.8,67.8,68,70.6,64.6,70.6L64.6,70.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDate);
export default __webpack_public_path__ + "static/media/ico-date.65ce59b63a2b41b4ee82a20cd887846f.svg";
export { ForwardRef as ReactComponent };